<template>
  <div id="app">

    <div class="page first">
      <h1>
          <small class="big" style="position: relative;">
            Merge two PunkScapes today!
            <svg viewBox="0 0 558 31" style="transform: rotate(0.0204799deg) scale(1);">
                <path d="M13.953857435102348 7.2929207677084085L538.3290227811974 9.864611728794703L553.2729268872424 20.981878103578566L18.59028663066357 22.674455596700568L13.953857435102348 7.2929207677084085Z" style="fill: #1D1B28;"></path>
            </svg>
          </small>
          <img src="https://punkscape.xyz/assets/logo.827c0d7f.png" alt="Punkscape">
      </h1>
    </div>


    <div class="overview">
      <div>
        <div class="loading-wrapper" v-if="isLoading">
          <PunkLoading style="position: absolute; margin-top: 15rem;" />
        </div>
        <canvas id="mergedPunkscape" />
      </div>
      <div class="download" v-if="isLoaded">
        Download: Right click image and "Save image as..."
      </div>
      <div class="download">
        Note: This will have no affect on the ETH blockchain
      </div>
    </div> 


    <div class="inputs">
      <input min="1" max="10000" type="number" class="scapeInput" v-model="scapeid_1" placeholder="ID 1"     oninput="javascript: if (this.value.length > 5) this.value = this.value.slice(0, 5);">
      <PunkButton text="Merge" @click.native="mergePunkScapes"/>
      <input min="1" max="10000" type="number" class="scapeInput" v-model="scapeid_2" placeholder="ID 2"    oninput="javascript: if (this.value.length > 5) this.value = this.value.slice(0, 5);">
    </div>
  </div>
</template>

<script>

import axios from 'axios'

import PunkButton from './components/PunkButton'
import PunkLoading from './components/PunkLoading'

export default {
  name: 'App',
  components: {
    PunkButton,
    PunkLoading
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      scapeid_1: "",
      scapeid_2: "",
      punkscape_url_1: undefined,
      punkscape_url_2: undefined,
      imgWidth: window.innerWidth / 2,
      imgHeight: ( window.innerWidth / 2 ) / 3,
      isLoaded: false,
      isLoading: false
    }
  },
  methods: {
    mergePunkScapes() {

      const imgWidth = this.imgWidth;
      const imgHeight = this.imgHeight;
      const windowWidth = this.windowWidth;

      this.isLoading = true;

      var canvas = document.getElementById("mergedPunkscape");

      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      
      this.retrievePunkScapeData(this.scapeid_1, (response) => {
        const punkscape_url_1 = response.data["image_lg"]
          this.punkscape_url_1 = punkscape_url_1

        this.retrievePunkScapeData(this.scapeid_2, (response_2) => {
          const punkscape_url_2 = response_2.data["image_lg"]
          this.punkscape_url_2 = punkscape_url_2

          var c = document.getElementById("mergedPunkscape");

          c.height = imgHeight;
          c.width = windowWidth;

          var ctx = c.getContext("2d");
          ctx.imageSmoothingEnabled = false; 

          var imageObj1 = new Image();
          var imageObj2 = new Image();
          imageObj1.src = punkscape_url_1;
          //imageObj1.crossOrigin="anonymous"

          imageObj1.onload = () => {
            ctx.drawImage(imageObj1, 0, 0, imgWidth, imgHeight);
            imageObj2.src = punkscape_url_2;
            //imageObj2.crossOrigin="anonymous"
            imageObj2.onload = () => {
                ctx.drawImage(imageObj2, imgWidth, 0, imgWidth, imgHeight);

                this.isLoaded = true;
                this.isLoading = false;
            };
          };

        })
      })

    },
    retrievePunkScapeData(_id, callback) {
      axios
      .get('https://api.punkscape.xyz/punkscapes/' + _id)
      .then(response => (
        callback(response, undefined)
        )
      )
    },
    onResize() {
        this.windowWidth = window.innerWidth
        this.imgWidth = window.innerWidth / 2,
        this.imgHeight = ( window.innerWidth / 2 ) / 3

    }
  },
  mounted() {
      this.$nextTick(() => {
          window.addEventListener('resize', this.onResize);
      })
  },
  beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
  }
}
</script>

<style>
html {
  background: black;
}

body {
  margin: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.overview {
  margin-top: 1.5rem;
}


.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 500;
}


h1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: var(--size-6) 0 0;
    position: relative;
    z-index: 50;
}

h1 small {
    display: inline-block;
    margin: 0 0 2rem!important;
    transform: rotate(-2deg);
    position: relative;
    font-family: "Space Mono", monospace, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    color: white;
}

h1 small svg {
    position: absolute;
    top: -10%;
    left: -10%;
    width: 120%;
    height: 120%;
    z-index: -1;
}




canvas {
  image-rendering: pixelated;
}



input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
.inputs {
  margin-top: 0.5rem;
}


.download {
  color: rgb(255, 4, 180);
  font-size: 13px;
  font-family: 'Space Mono',monospace,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
  font-weight: 400;

}

.scapeInput {
  font-family: 'Space Mono',monospace,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
  border: none;
  background: #232B37;
  border-radius: 5px;
  padding: 1rem;
  color: white;
  outline: none;
  margin: 1.5rem;
  width: 5rem;
  font-size: 1.5rem;
}

.scapeInput:focus {
  text-decoration: none;
}


</style>
